const clientType = ({ displayName, imgURL, imgURL2, clientTypeId  }) => `
    <div>
        <button data-value="${clientTypeId}" data-type="${displayName}" data-btn="client-type" data-target="select-pet" class="btn btn-dusk-outline btn-selecter btn-selecter--left">
            <img class="off-hover-icon js-confirm-img" alt="${displayName}" src="${imgURL}">
            <img class="on-hover-icon" alt="${displayName}" src="${imgURL2}">
            ${displayName}
        </button>
    </div>
`;


const petType = ({ displayName, imgURL, imgURL2, speciesId  }) => `
    <div>
        <button data-value="${speciesId}" data-type="${displayName}" class="btn btn-dusk-outline btn-selecter btn-selecter--left js-show-step js-btn-selecter">
            <img class="off-hover-icon js-confirm-img" alt="${displayName}" src="${imgURL}">
            <img class="on-hover-icon" alt="${displayName}" src="${imgURL2}">
            ${displayName}
        </button>
    </div>
`;

const otherPetType = ({ displayName, speciesId  }) => `
    <li data-value="${speciesId}" role="option" class=""><a href="#" class="js-other-pet-selecter" data-value="${speciesId}" data-type="${displayName}" data-filter="${displayName}">${displayName}</a></li>
`;

const existPet = ({ displayName, imgURL, petId, careClub, species  }) => `
    <div>
        <button data-pet-id="${petId}" data-pet-name="${displayName}" data-species="${species}" data-careclub="${careClub}" data-target="appt-reason" class="btn btn-dusk-outline btn-selecter btn-selecter--thumb btn-selecter--left js-exist-pet-btn">
        <div class="btn-selecter--thumb__icon">
            <img data-object-fit="cover" class="js-confirm-img" alt="${displayName}" src="${imgURL}">
        </div>
            ${displayName}
        </button>
    </div>
`;


const apptType = ({ name, imgURL, imgURL2, id, appointmentTypeId }) => `
    <div>
        <button data-btn="apptype" data-target="appt-issue" data-id="${id}"  data-appointmentTypeId="${appointmentTypeId}" class="js-show-next btn btn-dusk-outline btn-selecter btn-selecter--left">
        <img class="off-hover-icon" alt="${name}" src="${imgURL}">
        <img class="on-hover-icon" alt="${name}" src="${imgURL2}">
        ${name}
        </button>
    </div>
`;



const apptTypeNoImage = ({ name, id, appointmentTypeId }) => `
    <div>
        <button data-btn="apptype" data-target="appt-issue" data-id="${id}"  data-appointmentTypeId="${appointmentTypeId}" class="js-show-next btn btn-dusk-outline btn-selecter btn-selecter--left">
        ${name}
        </button>
    </div>
`;

const apptTypeContact = ({ name, imgURL, imgURL2, id, appointmentTypeId }) => `
    <div>
        <button data-btn="apptype" data-toggle="modal" data-target="#appttypemodal-${id}" data-target="appt-issue" data-id="${id}"  data-appointmentTypeId="${appointmentTypeId}" class="btn btn-dusk-outline btn-selecter js-modal-btn btn-selecter--left">
        <img class="off-hover-icon" alt="${name}" src="${imgURL}">
        <img class="on-hover-icon" alt="${name}" src="${imgURL2}">
        ${name}
        </button>
    </div>
`;

const apptReason = ({ name, id, appointmentTypeId }) => `
    <div data-appointmentTypeId="${appointmentTypeId}" style="display:none;">
        <button data-btn="reason" data-target="appt-issue" data-id="${id}" data-reason="${name}"  data-appointmentTypeId="${appointmentTypeId}" class="btn btn-dusk-outline btn-selecter js-show-textarea js-btn-selecter">
        ${name}
        </button>
    </div>
`;
const apptTypeModal = ({ body, id, name }) => `
    <div class="modal fade" id="appttypemodal-${id}" tabindex="-1" role="dialog" aria-labelledby="${name}" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel"></h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div class="modal-body">
                ${body}
                </div>
                <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
`;

const assetBlock = ({ displayName, ResourceCreds, imgURL, resourceId }) => `
    <div class="asset-block" data-resource-id="${resourceId}">
        <div class="asset-block__image">
            <img  src="${imgURL}" />
        </div>
        <div class="asset-block__content">
            <div class="asset-block__name">${displayName}</div>
            <div class="asset-block__creds">${ResourceCreds}</div>
        </div>
    </div>
`;

const timeBtn = ({ displayTime, resourceId, startTime, endTime, displayDate }) => `
    <button data-resource-id="${resourceId}" data-start-time="${startTime}" data-end-time="${endTime}" data-time-display="${displayTime}" data-date-display="${displayDate}" class="js-select-appt asset-appt-time-btn">${displayTime}</button>
`;

const vetTimeAssets = ({ displayDate , content}) => `
    <div class="v-asset-times__item"><div class="v-asset-times__item__date">${displayDate}</div>${content}</div>
`;


const wellnessBtnDueDate = ({ displayName , IconUrl, wellnessTypeId, id, DueDate, careClubIcon}) => `
    <button data-wellnessType-Id="${wellnessTypeId}" data-id="${id}" data-type-name="${displayName}"
        class="btn btn-dusk-outline btn-selecter btn-selecter-wellness btn-selecter--left js-btn-wellness">
        <div class="btn-selecter-wellness__img">
            <img class="${careClubIcon}" alt="wellness"
            src="${IconUrl}">
        </div>
        <div class="flex-fill">
            <div><strong>${displayName}</strong></div>
            <span class="sm-label">Due Date</span> ${DueDate}
        </div>
        <div class="radial-btn"></div>
    </button>
`;

const wellnessBtn = ({ displayName , IconUrl, wellnessTypeId, id, DueDate, careClubIcon}) => `
    <button data-wellnessType-Id="${wellnessTypeId}" data-id="${id}" data-type-name="${displayName}"
        class="btn btn-dusk-outline btn-selecter btn-selecter-wellness btn-selecter--left js-btn-wellness">
        <div class="btn-selecter-wellness__img">
            <img class="${careClubIcon}" alt="wellness"
            src="${IconUrl}">
        </div>
        <div class="flex-fill">
            <div><strong>${displayName}</strong></div>
        </div>
        <div class="radial-btn"></div>
    </button>
`;

const petInputGroup = ({ displayName }) => `
    <div class="form-label-group">
        <div class="form-check custom-radio">
            <input class="form-check-input custom-control-input" type="radio" name="petName" id="${displayName}" value="${displayName}">
            <label class="form-check-label" for="${displayName}">
            ${displayName}
            </label>
        </div>
    </div>
`;




export {
    clientType,
    petType,
    otherPetType,
    existPet,
    apptType,
    apptTypeNoImage,
    apptReason,
    apptTypeContact,
    apptTypeModal,
    assetBlock,
    timeBtn,
    vetTimeAssets,
    wellnessBtn,
    wellnessBtnDueDate,
    petInputGroup
};
